// extracted by mini-css-extract-plugin
module.exports = {"loadingButton":"Loader_loadingButton__gSd0g"};